import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiUpdateUserTosRequestBody,
  IApiUpdateUserTosResponseBody,
} from '../UsersApi.types';
import { useApi } from '~/lib/api/useApi';
import { userQueryKeyFactory } from './useUserQuery';

export type IUseUpdateUserTosMutationValues = {
  userId: string;
  body: IApiUpdateUserTosRequestBody;
};

export const useUpdateUserTosMutation = (): UseMutationResult<
  IApiUpdateUserTosResponseBody,
  unknown,
  IUseUpdateUserTosMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values) => api.users.updateTos(values.userId, values.body),
    onSuccess: async (_, values) => {
      // TODO once the API is updated to return the updated user, update the
      // query data
      // queryClient.setQueryData(
      //   userQueryKeyFactory({
      //     userId: updatedUser._id,
      //   }),
      //   updatedUser,
      // );

      // In the meantime:
      await queryClient.invalidateQueries({
        queryKey: userQueryKeyFactory(values),
      });
    },
  });
};
